import {Navigate, Route, Routes} from 'react-router-dom';
import ViewEvent from './views/ViewEvent/ViewEvent';
import RestrictedAccess from './components/feedback/RestrictedAccess';

// mui
import CreateEvent from './views/CreateEvent/CreateEvent';
import CreateOrUpdateAlert from './views/CreateOrUpdateAlert/CreateOrUpdateAlert';
import DashboardOperator from './views/Dashboard/DashboardOperator';
import DashboardWallboard from './views/Dashboard/DashboardWallboard';
import FullCalendar from "./views/Events/Calendar/FullCalendar";
import EventsTable from './views/Events/EventsTable';
import Layout from "./components/navigation/Layout";
import AffectedEntities from './views/AffectedEntities/AffectedEntities';
import WorkDatagrid from './views/Work/WorkDataGrid';


function App() {
    return (
        <Routes>
            <Route path="/dashboard/wallboard"                  element={<DashboardWallboard/>}/>
            <Route                                              element={<Layout/>}>
                <Route path="/"                                 element={<EventsTable/>}/>
                <Route path="/dashboard"                        element={<DashboardOperator/>}/>
                <Route path="/calendar"                         element={<FullCalendar/>}/>
                <Route path="/events/:id"                       element={<ViewEvent />} />
                <Route path="/events/:id/alerts/create"         element={<CreateOrUpdateAlert/>}/>
                <Route path="/events/:id/alerts/:alertId"       element={<CreateOrUpdateAlert/>}/>
                <Route path="/events/:id/affected"              element={<AffectedEntities/>}/>
                <Route path="/events/create"                    element={<CreateEvent/>}/>
                <Route path="/work"                             element={<WorkDatagrid />} />
                <Route path="logout-callback"                   element={<div />} />
                <Route path="/404"                              element={<RestrictedAccess errorCode={404}/> } />
                <Route path="*"                                 element={<Navigate replace to="/404" />} />
            </Route>
        </Routes>
    );
}

export default App;